export const APP_DOCS_STATUS = {
  REQUIRED: 'required',
  RECEIVED_BACK: 'received_back',
  RECEIVED_FRONT: 'received_front',
  INVALID: 'invalid',
  APPROVED: 'approved',
  PENDING_REVIEW: 'pending_review'
};

export const ACCEPT_DOCS_STATUS = [
  APP_DOCS_STATUS.REQUIRED,
  APP_DOCS_STATUS.RECEIVED_FRONT,
  APP_DOCS_STATUS.RECEIVED_BACK,
  APP_DOCS_STATUS.INVALID
];

export const RESPONSE_STATUS = {
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};
